function getFocusableElements(container) { return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")) }
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first)
            return;
        document.addEventListener('keydown', trapFocusHandlers.keydown)
    };
    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown)
    };
    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus()
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus()
        }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus()
}

function pauseAllMedia() { }

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus()
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: !0
        })
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
    }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait)
    }
}
const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key)
    }
    return JSON.stringify(obj)
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    }
}
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {}
}
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments)
    }
};
Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent('on' + eventName, callback)
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options.method || 'post';
    var params = options.parameters || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField)
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form)
};

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
        this.addEventListener('click', (event) => {
            if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
        });
        this.addEventListener('keyup', () => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide()
        })
    }
    show(opener) {
        this.openedBy = opener;
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        this.querySelector('.template-popup')?.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'))
    }
    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia()
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const button = this.querySelector('button');
        button?.addEventListener('click', () => {
            document.querySelector(this.getAttribute('data-modal'))?.show(button)
        })
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this))
    }
    loadContent() {
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0));
            this.setAttribute('loaded', !0);
            window.pauseAllMedia();
            this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
        }
    }
}
customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange)
    }
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(!0, '', !1);
        this.updatePickupAvailability();
        if (!this.currentVariant) {
            this.toggleAddButton(!0, '', !0);
            this.setUnavailable()
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo()
        }
    }
    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
    }
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option
            }).includes(!1)
        })
    }
    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const newMedia = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!newMedia) return;
        const parent = newMedia.parentElement;
        parent.prepend(newMedia);
        window.setTimeout(() => {
            parent.scrollTo(0,0)
        })
    }
    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
    }
    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: !0
            }))
        })
    }
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id)
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = ''
        }
    }
    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`).then((response) => response.text()).then((responseText) => {
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
        })
    }
    toggleAddButton(disable = !0, text, modifyClass = !0) {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        if (!addButton) return;
        if (disable) {
          
            addButton.setAttribute('disabled', !0);
            if (text) addButton.textContent = text
        } else {
          
            addButton.removeAttribute('disabled');
            addButton.innerHTML =`<div class="atc-wrap"><span style="margin-right:7px;"> <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 138.06 209.9" width="13" height="20"> <defs> <style> .cls-1 { fill: none; stroke: #161616; stroke-miterlimit: 10; stroke-width: 8.79px; } </style> </defs> <path class="cls-1" d="M80.9,205.51h-23.75c-29.02,0-52.76-23.74-52.76-52.76l4.4-40.68c0-14.51,5.94-27.7,15.5-37.26,1.97-1.97,3.77-3.44,4.49-4.01,12-9.47,25.25-11.2,32.77-11.49h14.96c29.02,0,52.76,23.74,52.76,52.76l4.4,40.68c0,29.02-23.74,52.76-52.76,52.76Z"></path> <path class="cls-1" d="M14.56,88.22C11.83,47.48,33.92,4.4,68.95,4.4c34.48,0,52.23,35.62,54.55,83.82"></path> </svg></span><span class="cartPriceAdd">ADD TO BAG</span><span class="cartLoader">Adding...</span></div>`
        }
        if (!modifyClass) return
    }
    setUnavailable() {
        const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
        if (!addButton) return;
        addButton.textContent = window.variantStrings.unavailable;
        document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden')
    }
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData
    }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super()
    }
    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
        })
    }
}
customElements.define('variant-radios', VariantRadios);



class ProductModel extends DeferredMedia {
    constructor() {
        super()
    }
    loadContent() {
        super.loadContent();
        Shopify.loadFeatures([{
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
        }, ])
    }
    setupModelViewerUI(errors) {
        if (errors) return;
        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'))
    }
}
customElements.define('product-model', ProductModel);

window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([{
            name: 'shopify-xr',
            version: '1.0',
            onLoad: this.setupShopifyXR.bind(this),
        }, ])
    },
    setupShopifyXR(errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
            return
        }
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove()
        });
        window.ShopifyXR.setupXRElements()
    },
};
window.addEventListener('DOMContentLoaded', () => {
    window.ProductModel?.loadShopifyXR()
});

class PickupAvailability extends HTMLElement {
    constructor() {
        super();
        if (!this.hasAttribute('available')) return;
        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(!0);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId)
    }
    fetchAvailability(variantId) {
        const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then(response => response.text()).then(text => {
            const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML)
        }).catch(e => {
            this.querySelector('button')?.removeEventListener('click', this.onClickRefreshList);
            this.renderError()
        })
    }
    onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId)
    }
    renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);
        this.querySelector('button').addEventListener('click', this.onClickRefreshList)
    }
    renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
            this.innerHTML = "";
            this.removeAttribute('available');
            return
        }
        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
        this.querySelector('button').addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target)
        })
    }
}
customElements.define('pickup-availability', PickupAvailability);

class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
        super();
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.querySelector('button').addEventListener('click', () => {
            this.hide()
        });
        this.addEventListener('keyup', () => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide()
        })
    }
    handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
            this.hide()
        }
    }
    hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement)
    }
    show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this)
    }
}
customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);